export enum SsoProviders {
  Okta = 'okta',
  OneLogin = 'oneLogin',
  Google = 'google',
  Other = 'other',
}
